var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCpu = function SvgCpu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1316CF",
    clipPath: "url(#cpu_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7 5.3H5.3v6.4h6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7 9.3c.48 0 .8-.32.8-.8 0-.4-.32-.8-.8-.8h-.8V6.1h.8c.48 0 .8-.32.8-.8 0-.4-.32-.8-.8-.8h-.8v-.8c0-.88-.72-1.6-1.6-1.6h-.8v-.8c0-.4-.32-.8-.8-.8-.4 0-.8.32-.8.8v.8H9.3v-.8c0-.4-.32-.8-.8-.8s-.8.32-.8.8v.8H6.1v-.8c0-.4-.32-.8-.8-.8s-.8.32-.8.8v.8h-.8c-.88 0-1.6.72-1.6 1.6v.8h-.8c-.48 0-.8.32-.8.8 0 .4.32.8.8.8h.8v1.6h-.8c-.48 0-.8.32-.8.8 0 .4.32.8.8.8h.8v1.6h-.8c-.48 0-.8.32-.8.8 0 .4.32.8.8.8h.8v.8c0 .88.72 1.6 1.6 1.6h.8v.8c0 .4.32.8.8.8s.8-.32.8-.8v-.8h1.6v.8c0 .4.32.8.8.8s.8-.32.8-.8v-.8h1.6v.8c0 .4.32.8.8.8.4 0 .8-.32.8-.8v-.8h.8c.88 0 1.6-.72 1.6-1.6v-.8h.8c.48 0 .8-.32.8-.8 0-.4-.32-.8-.8-.8h-.8V9.3zm-2.4 4H3.7V3.7h9.6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cpu_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.5h16v16H.5z"
  })))));
};
export default SvgCpu;